module.exports = __webpack_public_path__ + "static/media/FasadOst.fa8a53f5.JPG";